export const INCH = 0.393701;

export function cmToPoint(cm: number) {
	return cm * INCH * 72;
}
